export enum RouterPaths {
  Root = '/',
  Dashboard = '/dashboard',

  // sidebar menu pages
  FeeGroups = '/fee-groups',
  FeeGroupDetails = '/fee-groups/:fee_group_id/fee-group-details',
  Fees = '/fee-groups/:fee_group_id/fee-group-details/fees',
  FeeLevels = '/fee-groups/:fee_group_id/fee-group-details/fee-levels',
  ProviderFees = '/provider-fees',
  ProvidersFee = '/provider-fees/:provider/fees',
  BlockchainFeeMarkups = '/blockchain-fee-markups',
  ExchangeFeeGroups = '/exchange-fee-groups',
  MerchantCoinConfig = '/merchant-coin-configs',
  MerchantConfig = '/merchant',
  ExchangeFees = '/exchange-fee-groups/:exchange_fee_group_id/exchange-fee',
  Profiles = '/profiles',
  Transactions = '/transactions',
  Transaction = '/transactions/:transactionId',
  Withdrawals = '/withdrawals',
  Invoices = '/deposit-invoices',
  ExchangeRates = '/exchange-rates',
  Reports = '/reports',
  Dictionaries = '/dictionaries',
  UserAndRoles = '/users-and-roles',
  BlockchainFee = '/blockchain-fee',
  TransitAddresses = '/transit-addresses',
  TransitWithdrawals = '/transit-addresses/:address_id',
  Providers = '/providers',
  ABFPaymentApps = '/abf-payment-apps',
  NotificationTemplates = '/notification-templates',
  NotificationTemplate = '/notification-templates/:eventName',

  // profile pages
  Profile = '/profiles/:profileUid',
  ProfileDetails = '/profiles/:profileUid/details',
  ProfileDocuments = '/profiles/:profileUid/documents',
  ProfileBankAccounts = '/profiles/:profileUid/bank-accounts',
  ProfileWallets = '/profiles/:profileUid/wallets',
  ProfileTransactions = '/profiles/:profileUid/transactions',
  ProfileTransaction = '/profiles/:profileUid/transactions/:transactionId',
  // ProfileMerchantCoinConfig = '/profiles/:profileUid/merchant-config',
  ProfileMerchantConfig = '/profiles/:profileUid/merchant-config',
  ProfileMerchantPayments = '/profiles/:profileUid/merchant-payments',
  ProfileMerchantPaymentDetails = '/profiles/:profileUid/merchant-payments/:request_uid',
  ProfileMerchantPaymentDetailsTransaction = '/profiles/:profileUid/merchant-payments/:request_uid/transactions/:transactionId',
  ProfileSumsubInfo = '/profiles/:profileUid/sumsub-info',
  ProfileSandboxUsers = '/profiles/:profileUid/sandbox-users',

  // dictionaries pages
  Countries = '/dictionaries/countries',
  CompanyTypes = '/dictionaries/company-types',

  // users and roles pages
  Users = '/users-and-roles/users',
  Roles = '/users-and-roles/roles',
  RoleDetails = '/users-and-roles/roles/:roleId',

  // kraken pages
  ProvidersWallets = '/providers/:provider/wallets',
  Ledgers = '/providers/:provider/ledgers',

  // application pages
  Application = '/app-tokens',
  ApplicationTokens = '/app-tokens/:applicationUid',
}
